import { AbstractControl } from "@angular/forms";

export const checkDuplicateDisplayNameControl = (control: AbstractControl) => {
  const currentValue = control.value;
  const parent = control.parent;

  if (!parent || !parent.parent) {
    return null; 
  }

  const formArray = parent.parent; 

  if (!formArray || !Array.isArray(formArray.controls)) {
    return null;
  }

  const alldisplayNames = formArray.controls.map(group => group.get('displayName')?.value);

  const duplicateCount = alldisplayNames.filter(name => name === currentValue).length;

  if (duplicateCount > 1) {
    return { duplicateDisplayName: true , errorMessage: 'This Display Name already exists. Please enter a unique name.'};
  }

  return null;
}